module.exports = __webpack_public_path__ + "static/media/tese_aline.a666b2f5.png";